/**
 * Sidebar invite inbox: which pending invites belong on the current tab, and
 * which banner copy to use for that filtered set.
 */

import {
  showConversationsInList,
  showSpacesInList,
  type SidebarListView,
} from './sidebarListView';
import type { InviteInboxType } from '@adieuu/shared';

export type InvitationNoticeKind = 'chat' | 'space' | 'mixed';

export function inviteInboxTypesForListView(listView: SidebarListView): InviteInboxType[] {
  if (listView === 'spaces') return ['space'];
  if (listView === 'conversations') return ['group'];
  return ['space', 'group'];
}

export function filterInvitesForListView(
  listView: SidebarListView,
  groupCount: number,
  spaceCount: number,
): { groupCount: number; spaceCount: number } {
  return {
    groupCount: showConversationsInList(listView) ? groupCount : 0,
    spaceCount: showSpacesInList(listView) ? spaceCount : 0,
  };
}

export function invitationNoticeKind(
  groupCount: number,
  spaceCount: number,
): InvitationNoticeKind | null {
  if (groupCount <= 0 && spaceCount <= 0) return null;
  if (groupCount > 0 && spaceCount > 0) return 'mixed';
  if (spaceCount > 0) return 'space';
  return 'chat';
}

export function invitationNoticeI18nKey(
  kind: InvitationNoticeKind,
): 'nav.chatInvitations' | 'nav.spaceInvitations' | 'nav.invitations' {
  if (kind === 'space') return 'nav.spaceInvitations';
  if (kind === 'mixed') return 'nav.invitations';
  return 'nav.chatInvitations';
}

export function invitationNoticeIcon(kind: InvitationNoticeKind): 'spaces' | 'message' {
  return kind === 'space' ? 'spaces' : 'message';
}
